import { postRequest } from '@/core';
import { packageTypes } from '@/requests';

export default async function newPackageTypeRequest(packageType) {
	let url = packageTypes.getPath();
	let response = await postRequest(url, {}, packageType);
	return response;
}